import { game } from './chess';
import { clickDrop } from './onDrop';
import { onMouseoverSquare } from './highlightpossiblemoves';

export const onDragStart: any = (
  source: any,
  piece: any,
  position: any,
  orientation: any,
): any => {
  clickDrop(source,piece);
  onMouseoverSquare(source, piece);

  if (game.isGameOver()) return false;

  // only pick up pieces for the side to move

  if (
    (game.turn() === 'w' && piece.search(/^b/) !== -1) ||
    (game.turn() === 'b' && piece.search(/^w/) !== -1)
  ) {
    return false;
  }

  let userDATA = JSON.parse(localStorage.getItem('loggedInUser') || '{}');
  let games = JSON.parse(localStorage.getItem('gameIdreponse') || '{}');

  if (window.location.pathname === `/play/${games._id}`) {
    if (
      games.whiteSidePlayer !== userDATA.username &&
      games.blackSidePlayer !== userDATA.username
    ) {
      return false;
    }
    if (
      (games.blackSidePlayer == userDATA.username &&
        piece.search(/^w/) !== -1) ||
      (games.blackSidePlayer !== userDATA.username && piece.search(/^b/) !== -1)
    ) {
      return false;
    }
  }
};
